export enum ProductType {
    AS_MOLDED = 'As Molded',
    FINISHED = 'Finished',
}